
const configure = auth0 => ({
    // called when the user attempts to log in
    login: (url) => {
        return Promise.resolve();
    },
    // called when the user clicks on the logout button
    logout: () => {
        if (auth0.isAuthenticated) { // need to check for this as react-admin calls logout in case checkAuth failed
            return auth0.logout({
                redirect_uri: window.location.origin,
                federated: true // have to be enabled to invalidate refresh token
            });
        }

        return Promise.resolve();
    },
    // called when the API returns an error
    checkError: ({status}) => {
        if (status === 401 || status === 403) {
            return Promise.reject();
        }
        return Promise.resolve();
    },
    // called when the user navigates to a new location, to check for authentication
    checkAuth: () => {
        if (auth0.isAuthenticated) {
            return Promise.resolve();
        }
        return auth0.getAccessTokenSilently()
    },
    // called when the user navigates to a new location, to check for permissions / roles
    getPermissions: async () => {
        let claims = await auth0.getIdTokenClaims();
        let attempts = 0;
        let maxAttempts = 5;

        while(claims === undefined && attempts < maxAttempts) {
            attempts++;
            claims = await auth0.getIdTokenClaims();
            await sleep(1000);
        }

        return Promise.resolve(claims['https://v1.panoscape.app/permissions']);
    },
});

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export default configure;